export const getHeaders = (tipoprecio) => {
  // tipoprecio:
  // 0 = Mayorista
  // 1 = Minorista
  // 2 = Costo

  const baseHeaders = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
      hidden: true,
    },
    {
      field: "art_codigo",
      headerName: "Código",
      width: 120,
    },
    {
      field: "art_descripcion",
      headerName: "Descripción",
      width: 280,
      flex: 1,
    },
    {
      field: "alp_art_npreciocosto",
      headerName: "Costo",
      width: 100,
      hidden: true,
    },
  ];

  const precioHeaders = [];

  if (Number(tipoprecio) === 0) {
    // Mayorista
    precioHeaders.push({
      field: "alp_art_npreciomayorista",
      headerName: "P. Mayorista",
      width: 120,
    });
  } else if (Number(tipoprecio) === 1) {
    // Minorista
    precioHeaders.push({
      field: "alp_art_nprecioventa",
      headerName: "P. Minorista",
      width: 120,
    });
  } else if (Number(tipoprecio) === 2) {
    // Costo
    precioHeaders.push({
      field: "alp_art_npreciocosto",
      headerName: "P. Costo",
      width: 120,
    });
  }

  const extraHeaders = [
    {
      field: "alp_porclista",
      headerName: "% Lista",
      width: 90,
    },
    {
      field: "alp_margen",
      headerName: "% Margen",
      width: 90,
    },
    {
      field: "alp_imp_fijo",
      headerName: "Imp. Fijo",
      width: 90,
      hidden: true,
    },
    {
      field: "alp_show_web",
      headerName: "Web",
      width: 90,
    },
    {
      field: "alp_show_app",
      headerName: "App",
      width: 90,
    },
  ];

  return [...baseHeaders, ...precioHeaders, ...extraHeaders];
};